import { Card } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import React from 'react';
import { Link } from 'react-router-dom';
import { ImageService } from '../../../main/services/ImageService/ImageService';
import FullScreenWrapperWithBranchLogo from '../FullScreenWrapperWithBranchLogo';
import { useStyles } from './ScreenResetPasswordLinkSent.styles';

const IMAGE_EMAIL_SENT_FILE_LOCATION = '/static/images/loggedout/img_email_sent.svg';

export const ScreenResetPasswordLinkSent = ({ userEmailAddress }: { userEmailAddress: string }) => {
  const { card, cardContent, cardTitle, image, checkYourEmailText, mainText, emailInBold, footer, linkColor } = useStyles();

  return (
    <FullScreenWrapperWithBranchLogo>
      <Card className={card}>
        <div className={cardContent}>
          <div id="reset-password-link-sent__header" className={cardTitle}>
            Link sent!
          </div>
          <img
            id="reset-password-link-sent__header-image"
            className={image}
            src={ImageService.getImageUrl(IMAGE_EMAIL_SENT_FILE_LOCATION)}
          />
          <div>
            <div className={checkYourEmailText}>Check your email</div>
            <p id="reset-password-link-sent__main-text" className={cx(mainText)}>
              We sent an email to
              <span className={emailInBold}>{` ${userEmailAddress} `}</span>
              with a link to reset the password. If you have not received the email after a few minutes, please check your
              spam folder.
            </p>
            <span id="reset-password-link-sent__footer" className={footer}>
              Haven't received the email?{' '}
              <Link id="reset-password-link-sent__try-again-link" className={linkColor} to="/reset-password">
                Try again
              </Link>
            </span>
          </div>
        </div>
      </Card>
    </FullScreenWrapperWithBranchLogo>
  );
};
